module.exports = __webpack_public_path__ + "img/badge-non-partner.a66cc0cb.png";